import React from 'react';
import PropTypes from 'prop-types';

import AnnotationControlsField from './components/AnnotationControlsField';
import { ERROR_TYPES, SEVERITIES_BY_GOCHECK_VERSION, ANNOTATION_TYPES } from '../../constants';
import './Annotation.css';


class Annotation extends React.Component {
  constructor(props) {
    super(props);
    this.getTagDisplay = this.getTagDisplay.bind(this);
  }

  getTagDisplay() {
    const {
      type, errorType, severity, gocheckVersion,
    } = this.props;
    if (type === ANNOTATION_TYPES.suggestion) {
      return (
        <span className="annotation-label suggestion">
          Suggestion
        </span>
      );
    }

    if (type === ANNOTATION_TYPES.issue) {
      const severities = SEVERITIES_BY_GOCHECK_VERSION[gocheckVersion];
      return (
        <span className={`annotation-label ${severity}`}>
          {ERROR_TYPES[errorType]}
          {' '}
          (
          {severities[severity]}
          )
        </span>
      );
    }

    return null;
  }

  render() {
    const {
      comment, onDelete, onEdit, isEditable,
    } = this.props;
    const tagDisplay = this.getTagDisplay();
    return (
      <div className="annotation-container p-0">
        { isEditable && <AnnotationControlsField onDelete={onDelete} onEdit={onEdit} /> }
        <p dir="auto" className="annotation-text">
          { comment || (<i>No comment</i>) }
        </p>
        {
          tagDisplay
            ? (
              <div className="annotation-labels">
                {tagDisplay}
              </div>
            )
            : null
        }
      </div>
    );
  }
}

Annotation.propTypes = {
  gocheckVersion: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  errorType: PropTypes.string,
  severity: PropTypes.string,
  comment: PropTypes.string,
  isEditable: PropTypes.bool,
};

Annotation.defaultProps = {
  errorType: '',
  severity: '',
  comment: '',
  isEditable: true,
};

export default Annotation;
